import { Component, Input, ChangeDetectionStrategy, OnInit, OnChanges } from '@angular/core';

import { Category, FinnairBoundItem, FinnairPassengerItem } from '../../api/models';
import { FinnairServiceItemWithUpsell } from '../../interfaces';
import { getCabinBaggageSummary, getCheckedBaggageSummary, getMealSummary, getSummary } from '../../utils';

interface ServiceSummary {
  quantity?: number;
  description: string;
}

@Component({
  selector: 'fin-included-product-item-summary',
  templateUrl: './included-product-item-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductItemSummaryComponent implements OnInit, OnChanges {
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;
  @Input() isShortHaulFlight: boolean;
  protected readonly Category = Category;
  protected otherServicesSummary: ServiceSummary[] = [];
  protected bagsServicesSummary: ServiceSummary[] = [];

  ngOnChanges(): void {
    this.update();
  }

  ngOnInit(): void {
    this.update();
  }

  private update() {
    switch (this.service?.category) {
      case Category.CABIN_BAGGAGE:
        this.otherServicesSummary = getCabinBaggageSummary(this.bound, this.service, this.passengers);
        break;
      case Category.BAGGAGE:
        this.bagsServicesSummary = getCheckedBaggageSummary(this.bound, this.service);
        break;
      case Category.MEAL:
        this.otherServicesSummary = [getMealSummary(this.bound, this.service, this.isShortHaulFlight)];
        break;
      case Category.WIFI:
      case Category.LOUNGE:
      case Category.SPORT:
      case Category.PET:
      case Category.PRIORITY:
      case Category.SPECIAL_NEED:
      case Category.COVER:
      case Category.OTHER:
        this.otherServicesSummary = [getSummary(this.bound, this.service)];
        break;
    }
  }
}
